import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  Input,
} from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { config } from '../../../../../config/config';
import { CustomEventCommand, CustomPlaceCommand } from '../../../../commands/hub/custom.event.command';
import { HubFacebookFeedsCommand } from '../../../../commands/hub/event/add.facebook.general.feed.command';
import { VisitorPromotionImageCommand } from '../../../../commands/hub/visitor.promotion.image.command';
import { TripStorageCommand } from '../../../../commands/visitor/create.trip.command';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { clone, isNullOrUndefined } from '../../../../common/extensions';
import { ModalService } from '../../../../common/services/modal.service';
import { HubCustomBtn } from '../../../../models/hub/hub.custom.btn';
import { HubFeed } from '../../../../models/hub/hub.feed';
import { HubVisitorPromotionImage } from '../../../../models/hub/hub.visitor.promotion.image';
import { AlertifyService } from '../../../../services/alertify.service';
import { ConfigService } from '../../../../services/config.service';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import {
  HubFacebookLocationFeedsStore,
  HubFacebookPageFeedsStore,
  CustomBtnStore,
  ToggleAndDataSourceStore,
  EditorChoiceStore,
} from '../../../../stores/hub.calendar.store';
import { HubComponent } from '../../hub.component';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EditorChoiceDataSource } from '../../../../models/hub/hub.event';
import { LocalStorageService } from '../../../../services/localStorageService';
import { PlaceType } from '../../place.category/customize.place.category.component';
import { ImageSelectorCommand } from '../../../../common/components/image.selector/image.selector.component';

@Component({
  selector: 'ig-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MarketingComponent extends BaseComponent implements OnInit {
  @Input() show: 'editor' | 'custom' | 'promotion';
  public hubName = null;
  public apiAddress = ConfigService.config.apiAddress;
  public promotionForm: FormGroup;
  public customEventForm: FormGroup;
  public customEditorChoiceForm: FormGroup;
  public isHideEditorChoice = true;
  public editorChoiceForEvent: string = '';
  public editorChoiceForPlace: string = '';
  public isLoadingEditorChoice = false;
  public isTurnOnCustomEvent = true;
  public isTurnOnCustomPlace = true;
  public visitorPromotionImageCommand = new VisitorPromotionImageCommand();
  public visitorPromotionImage = new HubVisitorPromotionImage();
  public customEventCommands: CustomEventCommand[]; //new CustomEventCommand();
  public customPlaceCommands: CustomPlaceCommand[];
  public customEventCommand = new CustomEventCommand();
  public customPlaceCommand = new CustomPlaceCommand();
  public hubPages: HubFeed[];
  public hubLocations: HubFeed[];
  public eventFeeds: any[];
  public placeFeeds: any[];
  public initialTitle = '';
  public isEditDisplayTitle = [];
  public isEditPlaceDisplayTitle = [];
  public defaultVisitorPromotionImg = null; //config.defaultVisitorPromotionImageUrl;
  public toggles = new HubVisitorFeatureToggle();
  public selectImgFile: ImageSelectorCommand = new ImageSelectorCommand();
  @ViewChildren('customEventRow') customEventRows: QueryList<ElementRef>;

  public version = {
    event: {
      version: 'V2',
    },
    place: {
      version: 'V2',
    },
    tripPlanner: {
      version: 'V2',
    },
    clientDashboard: {
      version: 'V2',
    },
  };

  constructor(
    private hubApiService: HubApiService,
    private formBuilder: FormBuilder,
    private parent: HubComponent,
    private customizationService: CustomizationApiService,
    private activatedRoute: ActivatedRoute,
    private imageService: ImageService,
    private modalService: ModalService,
    private customBtnStore: CustomBtnStore,
    private hubFacebookFeedsStore: HubFacebookPageFeedsStore,
    private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore,
    private toggleAndDataSourceStore: ToggleAndDataSourceStore,
    private editorChoiceStore: EditorChoiceStore,
    private alertify: AlertifyService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.parent.location = 'Marketing';
    this.isLoadingEditorChoice = true;
    this.hubPages = [];
    this.hubLocations = [];

    this.visitorPromotionImage.link = '';

    this.promotionForm = this.formBuilder.group({
      link: [null, []],
      isTop: [null, []],
    });
    this.customEditorChoiceForm = this.formBuilder.group({
      editorChoiceForEvent: [null, []],
      editorChoiceForPlace: [null, []],
    });
    this.customEventForm = this.formBuilder.group({
      isEventOn: [null, []],
      isPlaceOn: [null, []],
      btnText: [null, [Validators.required]],
      placeBtnText: [null, [Validators.required]],
      type: [null, []],
      feedId: [null, []],
    });

    this.customizationService
      .getIsHideEditorChoice(this.hubName)
      .subscribe((isHideEditorChoice) => {
        this.isHideEditorChoice = isHideEditorChoice == undefined ? false : isHideEditorChoice;
        this.isLoadingEditorChoice = false;
      });

    this.customizationService.getEditorChoice(this.hubName).subscribe((editorChoice) => {
      this.editorChoiceForEvent = editorChoice.editorChoiceForEvent || '';
      this.editorChoiceForPlace = editorChoice.editorChoiceForPlace || '';
    });

    this.customizationService.getCustomEvent(this.hubName).subscribe((data) => {
      let customEvents = data.customEvents || [];
      let customPlaces = data.customPlaces || [];
      this.processCustomEvents(customEvents);
      this.processCustomPlaces(customPlaces);
    });

    this.customizationService.getVisitorPromotionImage(this.hubName).subscribe((data) => {
      this.visitorPromotionImage.isDisabled = data.isDisabled || false;
      this.visitorPromotionImage.link = data.link || '';
      this.visitorPromotionImageCommand.isTop = data.isTop || false;

      if (data.image) {
        this.visitorPromotionImage.image = data.image;
      } else {
        this.visitorPromotionImage.image = this.defaultVisitorPromotionImg;
      }
    });

    this.customizationService.getIgVersion(this.hubName).subscribe((version) => {
      if (version && version.event) {
        this.version = version;
      }
      console.log('version', version);
    });

    this.hubFacebookFeedsStore.pagesCommand
      .takeUntil(this.isDestroyed)
      .subscribe((hubPages: HubFacebookFeedsCommand) => {
        this.hubPages = hubPages.hubPages;
        this.eventFeeds = hubPages.hubPages;
      });

    this.hubFacebookLocationFeedsStore.locationCommand
      .takeUntil(this.isDestroyed)
      .subscribe((hubLocations: HubFacebookFeedsCommand) => {
        this.hubLocations = hubLocations.hubPages || [];
        this.placeFeeds = hubLocations.hubPages || [];
        let events = hubLocations.hubPages
          ? hubLocations.hubPages.filter(
              (x) => !config.placeSocialName.any((y) => y === x.socialName)
            )
          : [];
        this.hubPages &&
          this.hubPages.forEach((page) => {
            page.title = page.title || '@' + page.name;
          });
        events.forEach((location) => {
          if (
            !location.title.endsWith('Performers,Venues, Ticketing Websites') &&
            !location.title.endsWith(location.socialName)
          ) {
            location.title = `${location.title} - ${
              location.socialName == 'eventful'
                ? 'Performers,Venues, Ticketing Websites'
                : location.socialName
            }`;
          }
        });
        this.eventFeeds = this.hubPages ? this.hubPages.concat(events) : events;
      });

    this.toggleAndDataSourceStore.toggleAndDataSourceCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggleCommand: HubVisitorToggleDataSource) => {
        if (toggleCommand.toggle) {
          this.toggles = toggleCommand.toggle;
        }
      });

    setTimeout(() => {
      this.parent.sidebar && this.parent.sidebar.loadLocationFeeds();
    });
  }

  public getCustomEventLink(id) {
    if (this.version.event.version === 'V2') {
      return `${config.serverDomain}${this.hubName}/custom-events/${id}`;
    } else if (this.version.event.version === 'V3') {
      return `${config.serverDomainV3}${this.hubName}/events/custom-events/${id}`;
    }
    throw Error('Please check the version');
  }

  public getCustomEventEmbedScript(id) {
    if (this.version.event.version === 'V2') {
      return `<div id="imgoingcalendar-wrapper" route="/${this.hubName}/custom-events/${id}" url-change="true">
              <app-root></app-root>
              <script type="text/javascript" src="https://imgoingcalendar.com/imgoingscript.js"></script>
            </div> `;
    } else if (this.version.event.version === 'V3') {
      return `<div id="imgoingcalendar-wrapper" route="/${this.hubName}/events/custom-events/${id}" url-change="true">
                <app-root></app-root>
                <script type="text/javascript" src="https://imgoingcalendar.com/imgoingscript.js"></script>
              </div> `;
    }
    throw Error('Please check the version');
  }

  public copyCustomEventsEmbedScript(id) {
    const content = this.getCustomEventEmbedScript(id);
    this.copyContentToClipboard(content);
  }

  public copyToClip(id) {
    const value = this.getCustomEventLink(id);
    let aux = document.createElement('input');
    aux.setAttribute('value', value);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    alert('URL is copied to the clipboard');
  }

  public dragEnter($event) {
    console.log('enter');
    if ($event && $event.currentTarget) {
      this.restoreItemStyle();
      $event.currentTarget.style.border = '2px dashed green';
    }
  }

  private restoreItemStyle() {
    this.customEventRows.toArray().forEach((x) => {
      (x as ElementRef).nativeElement.style.border = 'none';
    });
  }

  public onItemDrop(e: any, targetIndex: number) {
    console.log({ e });
    console.log({ targetIndex });
    const dragItemIndex = this.customEventCommands.indexOf(e.dragData as CustomEventCommand);
    console.log({ dragItemIndex });

    // swap items
    [this.customEventCommands[targetIndex], this.customEventCommands[dragItemIndex]] = [
      this.customEventCommands[dragItemIndex],
      this.customEventCommands[targetIndex],
    ];

    setTimeout(() => {
      this.restoreItemStyle();
    });

    this.saveCustomEvent();
  }

  public editDisplayTitle(index) {
    this.initialTitle = this.customEventCommands[index].btnText;

    for (let i = 0; i < this.isEditDisplayTitle.length; i++) {
      this.isEditDisplayTitle[i] = false;
    }
    setTimeout(() => {
      this.isEditDisplayTitle[index] = true;
    });
  }

  public editPlaceDisplayTitle(index) {
    this.initialTitle = this.customPlaceCommands[index].btnText;

    for (let i = 0; i < this.isEditPlaceDisplayTitle.length; i++) {
      this.isEditPlaceDisplayTitle[i] = false;
    }
    setTimeout(() => {
      this.isEditPlaceDisplayTitle[index] = true;
    });
  }

  public isEditAnyCategory() {
    return this.isEditDisplayTitle.some((x) => x) || this.isEditPlaceDisplayTitle.some((x) => x);
  }

  public cancelEditCustomEventBtnName(i: number) {
    this.customEventCommands[i].btnText = this.initialTitle;
    this.isEditDisplayTitle[i] = false;
  }
  public cancelEditCustomPlaceBtnName(i: number) {
    this.customPlaceCommands[i].btnText = this.initialTitle;
    this.isEditPlaceDisplayTitle[i] = false;
  }

  public updateCustomEventBtnName($event, btn, index) {
    if (
      this.customEventCommands
        .map((x) => x.btnText.toLowerCase())
        .some(
          (item, index) =>
            this.customEventCommands.map((x) => x.btnText.toLowerCase()).indexOf(item) !== index
        )
    ) {
      this.alertify.warning('Custom category name must be unique.');
      $event.immediateComplete();
      return;
    }

    this.customEventCommand.isTurnOn = this.isTurnOnCustomEvent;
    this.customizationService
      .setCustomEvent(this.hubName, {
        isTurnOn: this.isTurnOnCustomEvent,
        customEvents: this.customEventCommands,
      })
      .finally($event.complete)
      .subscribe((customBtns: HubCustomBtn) => {
        this.isEditDisplayTitle[index] = false;
        this.customBtnStore.customBtnCommand.next(customBtns);
        this.alertify.successfully('Update display text');
      });
  }

  public updateCustomPlaceBtnName($event, btn, index) {
    if (
      this.customPlaceCommands
        .map((x) => x.btnText.toLowerCase())
        .some(
          (item, index) =>
            this.customPlaceCommands.map((x) => x.btnText.toLowerCase()).indexOf(item) !== index
        )
    ) {
      this.alertify.warning('Custom category name must be unique.');
      $event.immediateComplete();
      return;
    }

    this.customPlaceCommand.isTurnOn = this.isTurnOnCustomPlace;
    this.customizationService
      .setCustomPlace(this.hubName, {
        isTurnOn: this.isTurnOnCustomPlace,
        customPlaces: this.customPlaceCommands,
      })
      .finally($event.complete)
      .subscribe((customBtns: HubCustomBtn) => {
        this.isEditPlaceDisplayTitle[index] = false;
        this.processCustomPlaces(customBtns.places);
        this.customBtnStore.customBtnCommand.next(customBtns);
        this.alertify.successfully('Update display text');
      });
  }

  public saveIsEditorChoice() {
    this.customizationService
      .setIsHideEditorChoice(this.hubName, this.isHideEditorChoice)
      .subscribe(() => {
        this.alertify.successfully("Change editor's choice status");
      });
  }

  public saveEditorChoice($event) {
    let params: EditorChoiceDataSource = {
      editorChoiceForEvent: this.editorChoiceForEvent || "EDITOR'S CHOICE",
      editorChoiceForPlace: this.editorChoiceForPlace || "EDITOR'S CHOICE",
    };
    this.customizationService
      .saveEditorChoice(this.hubName, params)
      .finally($event.complete)
      .subscribe(() => {
        this.alertify.successfully("Edit editor's choice");
        this.editorChoiceStore.infoCommand.next(params);
      });
  }

  public async savePromotion(event: ButtonTriggerEvent) {
    this.visitorPromotionImageCommand.link = this.visitorPromotionImage.link;
    this.visitorPromotionImageCommand.isDisabled = this.visitorPromotionImage.isDisabled;
    this.visitorPromotionImageCommand.isTop = this.visitorPromotionImage.isTop;

    // compress
    if (this.selectImgFile.image) {
      const base64 = await this.imageService.compressImageFileToBase64(
        this.selectImgFile.image,
        1200
      );
      const res = await this.hubApiService.uploadBase64ImageToAWS(base64, 1200);
      if (res.success) {
        this.visitorPromotionImageCommand.image = res.url;
      }
    }

    this.customizationService
      .setVisitorPromotionImage(this.hubName, this.visitorPromotionImageCommand)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Change promotion image');
      });
  }

  // public saveCustomEvent(event: ButtonTriggerEvent) {
  //     this.customEventCommand.isTurnOn = this.isTurnOnCustomEvent;
  //     this.customizationService.setCustomEvent(this.hubName, {
  //         isTurnOn: this.isTurnOnCustomEvent,
  //         customEventCommands: this.customEventCommands
  //     })
  //         .finally(event.complete)
  //         .subscribe((customBtns: HubCustomBtn) => {
  //             this.alertify.successfully('Change custom event button');
  //             this.processCustomEvents(customBtns.events);
  //             this.customBtnStore.customBtnCommand.next(customBtns);
  //         });
  // }

  public toggleCustomEvents() {
    if (!this.isTurnOnCustomEvent) {
      let actions = <ConfirmModalActions>{
        confirm: (event: ButtonTriggerEvent) => {
          this.customEventCommands = [];
          this.customEventCommand.isTurnOn = this.isTurnOnCustomEvent;
          this.customizationService
            .setCustomEvent(this.hubName, {
              isTurnOn: this.customEventCommand.isTurnOn,
              customEvents: [],
            })
            .finally(event.complete)
            .subscribe((customBtns: HubCustomBtn) => {
              this.customEventCommands = customBtns.events;
              this.customBtnStore.customBtnCommand.next(customBtns);
              this.alertify.successfully(`Custom event category turned off}`);
            });
        },
        cancel: (event: ButtonTriggerEvent) => {
          this.isTurnOnCustomEvent = !this.isTurnOnCustomEvent;
        },
      };
      let data = <ConfirmModalData>{
        confirmModalIcon: 'warning',
        confirmModalTitle: 'Alert',
        confirmModalDescription: `Are you sure you want to turn off the custom event category feature, this will remove all the existing custom categories`,
        confirmModalConfirmButtonText: 'Yes',
        confirmModalCancelButtonText: 'No',
        isAsync: true,
      };

      this.modalService.show({
        component: ConfirmModalComponent,
        providers: [
          { provide: ConfirmModalActions, useValue: actions },
          { provide: ConfirmModalData, useValue: data },
        ],
      });
      return;
    }

    // turn on
    this.addNewAndSaveEvent();
  }

  public toggleCustomPlaces() {
    if (!this.isTurnOnCustomPlace) {
      let actions = <ConfirmModalActions>{
        confirm: (event: ButtonTriggerEvent) => {
          this.customPlaceCommands = [];
          this.customPlaceCommand.isTurnOn = this.isTurnOnCustomPlace;
          this.customizationService
            .setCustomPlace(this.hubName, {
              isTurnOn: this.customPlaceCommand.isTurnOn,
              customPlaces: [],
            })
            .finally(event.complete)
            .subscribe((customBtns: HubCustomBtn) => {
              this.customPlaceCommands = customBtns.places;
              this.customBtnStore.customBtnCommand.next(customBtns);
              this.alertify.successfully(`Custom place category turned off}`);
            });
        },
        cancel: (event: ButtonTriggerEvent) => {
          this.isTurnOnCustomPlace = !this.isTurnOnCustomPlace;
        },
      };
      let data = <ConfirmModalData>{
        confirmModalIcon: 'warning',
        confirmModalTitle: 'Alert',
        confirmModalDescription: `Are you sure you want to turn off the custom place category feature, this will remove all the existing custom categories`,
        confirmModalConfirmButtonText: 'Yes',
        confirmModalCancelButtonText: 'No',
        isAsync: true,
      };

      this.modalService.show({
        component: ConfirmModalComponent,
        providers: [
          { provide: ConfirmModalActions, useValue: actions },
          { provide: ConfirmModalData, useValue: data },
        ],
      });
      return;
    }

    // turn on
    this.addNewAndSavePlace();
  }

  public saveCustomEvent(event?: ButtonTriggerEvent) {
    this.customEventCommand.isTurnOn = this.isTurnOnCustomEvent;
    this.customizationService
      .setCustomEvent(this.hubName, {
        isTurnOn: this.customEventCommand.isTurnOn,
        customEvents: this.customEventCommands,
      })
      .finally(event && event.complete)
      .subscribe((customBtns: HubCustomBtn) => {
        this.processCustomEvents(customBtns.events);
        this.customBtnStore.customBtnCommand.next(customBtns);
        this.alertify.successfully('Custom event category saved');
      });
  }

  public saveCustomPlace(event?: ButtonTriggerEvent) {
    this.customPlaceCommand.isTurnOn = this.isTurnOnCustomPlace;
    this.customizationService
      .setCustomPlace(this.hubName, {
        isTurnOn: this.customPlaceCommand.isTurnOn,
        customPlaces: this.customPlaceCommands,
      })
      .finally(event && event.complete)
      .subscribe((customBtns: HubCustomBtn) => {
        this.processCustomPlaces(customBtns.places);
        this.customBtnStore.customBtnCommand.next(customBtns);
        this.alertify.successfully('Custom place category saved');
      });
  }

  public addNewAndSaveEvent() {
    this.addNewCustomEventTab();
    this.saveCustomEvent();
  }

  public addNewAndSavePlace() {
    this.addNewCustomPlaceTab();
    this.saveCustomPlace();
  }

  public addNewCustomEventTab() {
    this.customEventCommands.push(this.createNewCustomEventCommand());
  }

  public addNewCustomPlaceTab() {
    this.customPlaceCommands.push(this.createNewCustomPlaceCommand());
  }

  public removeCustomEventBtn(id) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .deleteCustomEventBtn(this.hubName, id)
          .finally(event.complete)
          .subscribe((customBtns: HubCustomBtn) => {
            this.alertify.successfully('Delete custom event button');
            this.processCustomEvents(customBtns.events);
            this.customBtnStore.customBtnCommand.next(customBtns);
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to delete this button?',
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public removeCustomPlaceBtn(id) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .deleteCustomPlaceBtn(this.hubName, id)
          .finally(event.complete)
          .subscribe((customBtns: HubCustomBtn) => {
            this.alertify.successfully('Delete custom place button');
            this.processCustomPlaces(customBtns.places);
            this.customBtnStore.customBtnCommand.next(customBtns);
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to delete this button?',
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public transferPlaces(place: CustomPlaceCommand) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .transferPlaces(this.hubName, place._id)
          .finally(event.complete)
          .subscribe(() => {
            this.alertify.successfully('Transfer places');
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription:
        'Are you sure you want to transfer all places belong to this category to the corresponding custom place category?',
      confirmModalConfirmButtonText: 'Confirm',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    let isSameNameCustomCategoryExist = this.checkIfSameNameCustomCategoryExist(place);

    if (isSameNameCustomCategoryExist) {
      this.modalService.show({
        component: ConfirmModalComponent,
        providers: [
          { provide: ConfirmModalActions, useValue: actions },
          { provide: ConfirmModalData, useValue: data },
        ],
      });
    } else {
      this.alertify.warning(
        `You need to create a custom place category in the below "Organize & Edit Places Categories" section with the name "${place.btnText}" before transferring places`,
        10
      );
    }
  }

  public getCustomPlaceEmbedScript(placeId: number) {
    return `<div id="imgoingcalendar-wrapper" route="/${this.hubName}/places/fav/${placeId}" url-change="true">
          <app-root></app-root>
          <script type="text/javascript" src="https://imgoingcalendar.com/imgoingscript.js"></script>
      </div> `;
  }

  public getCustomPlaceMapViewEmbedScript(placeId: number) {
    return `<div id="imgoingcalendar-wrapper"
    route="/${this.hubName}/places-map/custom-places/${placeId}" url-change="true">
    <app-root></app-root>
    <script type="text/javascript" src="https://imgoingcalendar.com/imgoingscript.js"></script>
    </div>`;
  }

  public copyEmbedScript(placeId: number, type: string) {
    let script =
      type === 'url'
        ? this.getCustomPlaceEmbedScript(placeId)
        : this.getCustomPlaceMapViewEmbedScript(placeId);

    this.copyContentToClipboard(script);
  }

  private copyContentToClipboard(content: string) {
    let aux = document.createElement('input');
    aux.setAttribute('value', content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    this.alertify.success('Link is copied to the clipboard');
  }

  public copyJsonFeed(placeId: number) {
    let content = `${this.apiAddress}v2.0/${this.hubName}/places?type=${placeId}`;
    let aux = document.createElement('input');
    aux.setAttribute('value', content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    this.alertify.success('Link is copied to the clipboard');
  }

  private checkIfSameNameCustomCategoryExist(place: CustomPlaceCommand) {
    const customDefaultPlaceCategory =
      LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage();

    let isSameNameCustomCategoryExist = false;
    if (customDefaultPlaceCategory && customDefaultPlaceCategory.customCategories) {
      for (let customCategory of customDefaultPlaceCategory.customCategories) {
        const exist = this.getIfCategoryExistsInCustomCreated(
          place.btnText,
          customCategory as PlaceType
        );
        if (exist) {
          isSameNameCustomCategoryExist = true;
          break;
        }
      }
    }
    return isSameNameCustomCategoryExist;
  }

  private getIfCategoryExistsInCustomCreated(title: string, category: PlaceType) {
    console.log(`category.title: ${category.title},`, `title: ${title}`);
    console.log(category.title.toLowerCase() === title.toLowerCase());
    if (category.title.toLowerCase() === title.toLowerCase()) {
      return true;
    }

    for (let subCategory of category.subCategories) {
      const exist = this.getIfCategoryExistsInCustomCreated(title, subCategory);
      if (exist) return true;
    }

    return false;
  }

  public processCustomEvents(customEvents) {
    this.customEventCommands = [];
    this.isEditDisplayTitle = [];
    if (customEvents && customEvents.length) {
      this.isTurnOnCustomEvent = true;
      customEvents.forEach((event) => {
        this.customEventCommands.push(
          this.createNewCustomEventCommand(
            event._id,
            event.btnText,
            event.sourceType,
            event.feedId,
            event.pageFeedId,
            event.locationFeedId
          )
        );
        this.isEditDisplayTitle.push(false);
      });
    } else {
      this.isTurnOnCustomEvent = false;
      // this.customEventCommands.push(this.createNewCustomEventCommand());
    }
  }

  public processCustomPlaces(customPlaces) {
    this.customPlaceCommands = [];
    this.isEditPlaceDisplayTitle = [];
    if (customPlaces && customPlaces.length) {
      this.isTurnOnCustomPlace = true;
      customPlaces.forEach((place) => {
        this.customPlaceCommands.push(this.createNewCustomPlaceCommand(place._id, place.btnText));
        this.isEditPlaceDisplayTitle.push(false);
      });
    } else {
      this.isTurnOnCustomPlace = false;
      //this.customPlaceCommands.push(this.createNewCustomPlaceCommand());
    }
  }

  private createNewCustomEventCommand(
    _id?,
    btnText?,
    type?,
    feedId?,
    pageFeedId?,
    locationFeedId?
  ) {
    let command = new CustomEventCommand();
    command._id = _id || null;
    command.btnText = btnText || 'Custom Event Tab #' + (this.customEventCommands.length + 1);
    command.sourceType = type || 'selected';
    command.feedId = feedId || '';
    command.pageFeedId = pageFeedId || '';
    command.locationFeedId = locationFeedId || '';

    if (!_id) delete command._id;

    return command;
  }

  private createNewCustomPlaceCommand(_id?, btnText?) {
    let command = new CustomPlaceCommand();
    command._id = _id || null;
    command.btnText = btnText || 'Favorite Listing #' + (this.customPlaceCommands.length + 1);
    return command;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/customization/marketing/marketing.component.ts